export function get(obj, keys, def) {
  if (!obj) return def;
  let keyList = keys.split(".");
  for (let key of keyList) {
    if (!empty(obj[key])) {
      obj = obj[key];
    } else {
      return def;
    }
  }
  return obj;
}

export function empty(obj) {
  return obj === null || obj === undefined;
}

export function pick(obj, keys) {
  let newObj = {};
  keys.forEach(key => {
    newObj[key] = obj[key];
  });
  return newObj;
}
